import { render, staticRenderFns } from "./OAuthLoading.vue?vue&type=template&id=336ba6e2&lang=pug&"
import script from "./OAuthLoading.vue?vue&type=script&lang=js&"
export * from "./OAuthLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports